export default class Model {
  constructor(data = {}) {
    this.data = data;

    this.initializeFields();
  }

  static make(data) {
    return new this(data);
  }
}
